import {take, call, put} from 'redux-saga/effects';
import {
	fetchReceiptList,
	failFetchReceiptList,
	setReceiptListData,
	getPdfItemsReceipt,
	failGetPdfItemsReceipt,
	setPdfItemsReceipt,
	getPdfItemsReceiptMod,
	failGetPdfItemsReceiptMod,
	setPdfItemsReceiptMod,
	undoReceiptFlag,
	failUndoReceiptFlag,
	successUndoReceiptFlag,
	fetchCsvDataReceipt,
	failFetchCsvDataReceipt,
	setCsvDataReceipt,
	getPdfItemsReceiptSecom,
	failGetPdfItemsReceiptSecom,
	setPdfItemsReceiptSecom, getReceiptArrivalPdf, failGetReceiptArrivalPdf, successGetReceiptArrivalPdf
} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleFetchReceiptList() {
	while (true) {
		const action = yield take(`${fetchReceiptList}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'receipt-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchReceiptList({err: msg}));
			continue;
		}
		yield put(setReceiptListData(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfReceipt() {
	while (true) {
		const action = yield take(`${getPdfItemsReceipt}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-receipt/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsReceipt({err: msg}));
			continue;
		}
		yield put(setPdfItemsReceipt(Object.assign({}, payload, {})));
	}
}


export function* handleGetPdfReceiptMod() {
	while (true) {
		const action = yield take(`${getPdfItemsReceiptMod}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-receipt-mod/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsReceiptMod({err: msg}));
			continue;
		}
		yield put(setPdfItemsReceiptMod(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfReceiptSecom() {
	while (true) {
		const action = yield take(`${getPdfItemsReceiptSecom}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-receipt-secom/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsReceiptSecom({err: msg}));
			continue;
		}
		yield put(setPdfItemsReceiptSecom(Object.assign({}, payload, {})));
	}
}

export function* handleUndoReceiptFlag() {
	while (true) {
		const action = yield take(`${undoReceiptFlag}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'undo-consignee-flag/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUndoReceiptFlag({err: msg}));
			continue;
		}
		yield put(successUndoReceiptFlag(Object.assign({}, payload, {})));
	}
}

export function* handleFetchCsvDataFromReceipt() {
	while (true) {
		const action = yield take(`${fetchCsvDataReceipt}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-csv-receipt/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchCsvDataReceipt({err: msg}));
			continue;
		}
		yield put(setCsvDataReceipt(Object.assign({}, payload, {})));
	}
}

export function* handleGetReceiptArrivalPdf() {
	while (true) {
		const action = yield take(`${getReceiptArrivalPdf}`);
		const {payload, err} = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-receipt-arrival/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetReceiptArrivalPdf({err: msg}));
			continue;
		}
		yield put(successGetReceiptArrivalPdf(Object.assign({}, payload, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/receipt-list.js